import LocalizedString from '@/types/localized-string';
import AppRegion from '@/types/app-region';
import { LotWithTaxMetrics } from '@capintel/instruments-lib';

/** US-specific unrealized gain display fields */
export type UsUnrealizedGainFields = {
  shortTermUnrealizedGainLoss?: number;
  longTermUnrealizedGainLoss?: number;
  totalUnrealizedGainLoss?: number;
};

/** CA-specific unrealized gain display fields */
export type CaUnrealizedGainFields = {
  unrealizedGainLoss?: number;
};

export interface HoldingWithTaxData {
  _id: string;
  ticker?: string;
  name?: LocalizedString;
  purchaseDate?: Date | string;
  units?: number;
  costBasis?: number;
  marketValue?: number;
  currentAllocation?: number;
  comparisonItemId: string;
  // Target portfolio fields (when comparing to a target)
  valueChange?: number; // Dollar value change (Target Dollar Value - Current Dollar Value)
  estimatedRealizedGainLoss?: number;
  taxCostToReachTarget?: number;
  // Region-specific unrealized gain fields
  [AppRegion.US]?: UsUnrealizedGainFields;
  [AppRegion.CAN]?: CaUnrealizedGainFields;
  // Lots data for expandable sub-rows
  lots?: LotWithTaxMetrics[];
}

export enum TaxAnalysisTableKeys {
  ComparisonItemId = 'comparisonItemId',
  Ticker = 'ticker',
  Name = 'name',
  Units = 'units',
  PurchaseDate = 'purchaseDate',
  CostBasis = 'costBasis',
  MarketValue = 'marketValue',
  ShortTermUnrealizedGainLoss = 'shortTermUnrealizedGainLoss',
  LongTermUnrealizedGainLoss = 'longTermUnrealizedGainLoss',
  TotalUnrealizedGainLoss = 'totalUnrealizedGainLoss',
  UnrealizedGainLoss = 'unrealizedGainLoss',
  CurrentAllocation = 'currentAllocation',
  // Target portfolio columns
  ValueChange = 'valueChange',
  EstimatedRealizedGainLoss = 'estimatedRealizedGainLoss',
  TaxCostToReachTarget = 'taxCostToReachTarget',
}

export enum RowType {
  Total = 'total',
}

export type TaxAnalysisRow = {
  [TaxAnalysisTableKeys.Ticker]: string;
  [TaxAnalysisTableKeys.Name]: string;
  [TaxAnalysisTableKeys.PurchaseDate]: string;
  [TaxAnalysisTableKeys.Units]: number;
  [TaxAnalysisTableKeys.CostBasis]: number;
  [TaxAnalysisTableKeys.MarketValue]: number;
  [TaxAnalysisTableKeys.ShortTermUnrealizedGainLoss]: number;
  [TaxAnalysisTableKeys.LongTermUnrealizedGainLoss]: number;
  [TaxAnalysisTableKeys.TotalUnrealizedGainLoss]: number;
  [TaxAnalysisTableKeys.UnrealizedGainLoss]: number;
};
